import dayjs, { Dayjs } from 'dayjs';
import { TObrigacao } from '../../../../ts/types/ObrigacaoEtapa/Obrigacoes/Obrigacoes';

export const isDataDepoisDaVencimentoObrigacao = (data: Dayjs, obrigacao: TObrigacao | undefined) =>
	obrigacao?.dataVencimento ? data.isAfter(dayjs(obrigacao.dataVencimento), 'day') : false;
